var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.763 5.148c-.761-1.372-2.734-1.373-3.497-.002L3.654 17.027C2.912 18.36 3.876 20 5.402 20h13.202c1.524 0 2.488-1.637 1.749-2.97l-6.59-11.882zM11.5 14h1.023L13 8h-2l.5 6zm1.224 2.282c-.183-.188-.426-.282-.727-.282-.297 0-.538.095-.722.285a.992.992 0 0 0-.275.718.98.98 0 0 0 .275.715c.184.188.425.282.722.282.301 0 .544-.094.727-.282a.98.98 0 0 0 .276-.715.99.99 0 0 0-.276-.721z"
  })));
};
export default SvgError;